import { IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class GetItemsRequest {
    @ApiProperty()
    @IsNotEmpty({message:"Item Category Id should not be empty"})
    itemCategoryId: number;

    @ApiProperty()
    @IsNotEmpty({message:"Item Sub Category Id should not be empty"})
    itemSubCategoryId: number;
}